





































































































import mixins from 'vue-typed-mixins'

import I18N from '@/components/I18N.ts'
import Root from '@/components/Root.vue'
import WordformsTable from '@/components/WordformsTable.vue'
import * as UI from '@/helpers/UI.ts'

import axios from 'axios'

interface Data {
  lexeme: Lexeme | null
  wordforms: Wordform[] | null
  related: Lexeme[] | null
}

export default mixins(I18N).extend({
  components: {
    Root,
    WordformsTable
  },
  data (): Data {
    return {
      lexeme: null,
      wordforms: null,
      related: null
    }
  },
  watch: {
    '$route.query': {
      handler (): void {
        this.load()
      },
      immediate: true
    }
  },
  computed: {
    examples (): string[] {
      if (!this.lexeme || !this.lexeme.glosses) return []
      let egs = []
      for (let g of this.lexeme.glosses) {
        for (let e of g.examples || []) {
          if (e.type === 'full') {
            egs.push(e.example)
          }
        }
      }
      return egs
    }
  },
  methods: {
    // get lexeme and wordforms
    load (): void {
      axios.get(`${process.env.VUE_APP_API_URL}/lexemes/${this.$route.params.id}`)
        .then(response => {
          this.lexeme = response.data
          this.$store.dispatch('setTitle', (this.lexeme as Lexeme).lemma)
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
          this.lexeme = {} as Lexeme
        })
      axios.get(`${process.env.VUE_APP_API_URL}/lexemes/wordforms/${this.$route.params.id}?pending=1`)
        .then(response => {
          this.wordforms = response.data
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
          this.wordforms = []
        })
      axios.get(`${process.env.VUE_APP_API_URL}/lexemes/related/${this.$route.params.id}`)
        .then(response => {
          this.related = response.data
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
          this.related = []
        })
    },
    // Making helper functions available to template
    derivedForm: UI.derivedForm,
    agr: UI.agr
  },
  mounted (): void {
    this.$store.dispatch('setTitle', { key: 'title.lexeme' })
  }
})
